import { t } from 'i18next';

export enum UserRole {
  VIEWER = 'VIEWER',
  ANALYST = 'ANALYST',
  UPLOADER = 'UPLOADER',
  AUTH_ADMIN = 'AUTH_ADMIN',
  ADMIN = 'ADMIN',
}

export const getUserRoleLabel = (role: UserRole): string => {
  switch (role) {
    case UserRole.VIEWER:
      return t('userRoles.viewer');
    case UserRole.ANALYST:
      return t('userRoles.analyst');
    case UserRole.UPLOADER:
      return t('userRoles.uploader');
    case UserRole.AUTH_ADMIN:
      return t('userRoles.authAdmin');
    case UserRole.ADMIN:
      return t('userRoles.admin');
    default:
      return role;
  }
};
